export default function calcCounterClockwise(currRad: number, lastRad: number): boolean {
  let isClockwise: boolean;
  if (currRad - lastRad > Math.PI * 1.95) isClockwise = true;
  else if (currRad - lastRad < -Math.PI * 1.95) isClockwise = false;
  else isClockwise = currRad < lastRad;
  return isClockwise;
}
